import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../axios.js';

import './Resources/dashboard.css';


function Add_godown(){

  
  
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");

 
//saving default values with usestate
const state = useState();

//godown_name
const[godown_name,setgodown_name]=useState();const updategodown_name = (event) => { setgodown_name(event.target.value);}; const[godown_name_er,setgodown_name_er]=useState();
//godown_code
const[godown_code,setgodown_code]=useState();const updategodown_code = (event) => { setgodown_code(event.target.value);}; const[godown_code_er,setgodown_code_er]=useState();
//godown_remarks
const[godown_remarks,setgodown_remarks]=useState();const updategodown_remarks = (event) => { setgodown_remarks(event.target.value);}; const[godown_remarks_er,setgodown_remarks_er]=useState();

//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();




  
//******************* ADD GODOWN FUNCTION START ********************//
function addgodown(){

  //Setting Error Variables
setgodown_name_er(" ");setgodown_code_er(" ");setgodown_remarks_er();seterror_msg(" ");



  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))){
 
 
  axios.post("addgodown", {
   Log_id:logid,
   Token:token,
   Godown_name : godown_name,
   Godown_code:godown_code,
   Godown_remarks:godown_remarks,

  })
  .then((response) => {

  //godown Limit Reached
  if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }


  if((response.data.error)==100){ 
      //Remove Session Variables and redirect to login
     sessionStorage.removeItem("logStatus00");
     sessionStorage.removeItem("logId00");
     sessionStorage.removeItem("logToken00");
     sessionStorage.removeItem("BusyId00");
     sessionStorage.removeItem("BusyName00");
     sessionStorage.removeItem("CounterId00");

     window.location.replace("businesstools-login");
  }

   //Validation Errors
 if(response.data.validatorerror){
  setgodown_name_er(response.data.validatorerror.Godown_name);
  setgodown_code_er(response.data.validatorerror.Godown_code);
  setgodown_remarks_er(response.data.validatorerror.Godown_remarks);

}
//Invalid Entries
if(response.data.error==102){ 
  
  setgodown_name_er(response.data.godown_name_er);
  setgodown_code_er(response.data.godown_code_er);
  setgodown_remarks_er(response.data.godown_remarks_er);

  seterror_msg("Cannot Add Godown!");  }


  //Invalid Entries
  if(response.data.error==103){     seterror_msg(response.data.error_msg);  }

   //Transaction Entered Successfully
   if(response.data.successvar==1){        document.getElementById("success-card1").style.display="block";  }
   //Cannot Add Transaction
   else{  seterror_msg("Cannot Add Godown !"); }
  

});
}
 //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
   sessionStorage.removeItem("logStatus00");
   sessionStorage.removeItem("logId00");
   sessionStorage.removeItem("logToken00");
   sessionStorage.removeItem("BusyId00");
   sessionStorage.removeItem("BusyName00");
   sessionStorage.removeItem("CounterId00");

   window.location.replace("businesstools-login");
 
  }
 
 }
  
 //******************* ADD GODOWN FUNCTION END ********************//





return(
    <>
                <div class="card">
                <div class="d-flex justify-content-between">
                    <div></div>
                    <div>
                    
                      <button type="button" class="btn btn-social-icon" onClick={()=>{ document.getElementById("create-form1").style.display="none"; }}>
                      <i class="mdi mdi-close-box text-danger" style={{fontSize:"2rem"}}></i>
                      </button>
                      </div>
                    </div>
                  <div class="card-body">
                    <h4 class="card-title">Add Godown</h4>
                    <div class="form-sample">
                      <p class="card-description">enter your godown here</p>
                      <code>{error_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Godown Code</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="GCODE01" id="godown_code" value={godown_code} onChange={updategodown_code} />
                              <code>{godown_code_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Godown Name</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="ABC Godown" id="godown_name" value={godown_name} onChange={updategodown_name} />
                              <code>{godown_name_er}</code>
                            </div>
                          </div> 
                        </div>
                        </div>
                     
                      <div class="form-group">
                        <label for="exampleTextarea1">Remarks</label>
                        <textarea  class="form-control"  rows="2" id="godown_remarks" value={godown_remarks} onChange={updategodown_remarks}></textarea>
                      <code>{godown_remarks_er}</code>
                      </div>
                 
                      <div class="row">
                    
                        <div class="col-md-6">
                        <button class="btn btn-primary" style={{fontWeight:"bold"}} onClick={addgodown} >Add Godown</button>
                        </div>                     
                      </div>
                      
                      
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>
    </>

);

}

export default Add_godown;